"use strict";

/**
 * More Info Accordion
 */
if (typeof SDG.accordion !== 'undefined') {
  var moreInfoAccordion = SDG.accordion({
    dom: {
      id: 'moreInfoAcc',
    },
  });
  moreInfoAccordion.init();
}
/**
 * BIS Product Notify
 */

function updateBtnStyles() {
  const bisBtn = document.getElementById('BIS_trigger');

  function init() {
    if (bisBtn && !bisBtn.style.display === 'none') {
      bisBtn.style.width = '50%';
    }
  }

  return init();
}

updateBtnStyles();
/**
 * Overlay Utils
 */

function showPageOverlay() {
  const $modal = document.querySelector('[data-section-id=size-chart]');
  const $overlay = document.querySelector('.PageOverlay');

  if ($modal && $modal.getAttribute('aria-hidden') === 'false') {
    $overlay.classList.add('is-visible');
    document.documentElement.classList.add('no-scroll');
  } else {
    $overlay.classList.remove('is-visible');
    document.documentElement.classList.remove('no-scroll');
  }
}

function hideOverlay() {
  var $overlay = document.querySelector('.PageOverlay');

  if ($overlay.classList.contains('is-visible')) {
    $overlay.classList.remove('is-visible');
    document.documentElement.classList.remove('no-scroll');
  }
}
/**
 * Size Chart
 */

const $sizeChartOpen = document.getElementById('sizeChartOpen');
const $sizeChartClose = document.querySelector('.NewsletterPopup__Close');

function showSizeChart() {
  const $modal = document.querySelector('[data-section-id=size-chart]');

  if ($modal) {
    $modal.setAttribute('aria-hidden', 'false');
  }

  const $sizeChartModal = document.getElementById('sizeChartModal');
  $sizeChartModal.style.visibility = 'visible';
  $sizeChartModal.setAttribute('aria-hidden', 'false');

  $sizeChartClose.focus();
  trapFocus($modal); // trapFocus() is from custom.js

  $modal.addEventListener('keydown', (e) => {
    const escKey = e.keyCode === 27;
    if (escKey) {
      hideSizeChart();
    }
  });
}

function hideSizeChart() {
  const $sizeChartModal = document.getElementById('sizeChartModal');
  $sizeChartModal.style.visibility = 'hidden';
  $sizeChartModal.setAttribute('aria-hidden', 'true');
  hideOverlay();

  $sizeChartOpen.focus();
}
/**
 * Color Swatch Drawer
 */

const $colorDrawerTrigger = document.querySelector(
  '[data-drawer-id="openColorDrawer"]'
);
const $colorDrawerClose = document.querySelector(
  '[data-drawer-id="closeColorDrawer"]'
);

function openColorDrawer() {
  const $drawer = document.getElementById('colorDrawer');
  const $closeDrawer = document.getElementById('closeColorDrawer');

  if ($drawer) {
    $drawer.setAttribute('aria-hidden', 'false');

    setTimeout(() => {
      $closeDrawer.focus();
      trapFocus($drawer); // trapFocus() function is from custom.js
    }, 500);

    $drawer.addEventListener('keydown', (e) => {
      const escKey = e.keyCode === 27;
      if (escKey) {
        closeColorDrawer();
      }
    });
  }
}

function closeColorDrawer() {
  const $drawer = document.getElementById('colorDrawer');
  const $colorButton = document.getElementById('colorsButton');
  $drawer.setAttribute('aria-hidden', 'true');
  hideOverlay();

  $colorButton.focus();
}

function addEvents() {
  // event listeners for size chart
  if ($sizeChartOpen && $sizeChartClose) {
    $sizeChartOpen.addEventListener('click', showSizeChart);
    $sizeChartOpen.addEventListener('click', showPageOverlay);
    $sizeChartClose.addEventListener('click', hideSizeChart);
  } // event listeners for color drawer

  if ($colorDrawerTrigger && $colorDrawerClose) {
    $colorDrawerTrigger.addEventListener('click', openColorDrawer);
    $colorDrawerTrigger.addEventListener('click', showPageOverlay);
    $colorDrawerClose.addEventListener('click', closeColorDrawer);
  }
}

document.addEventListener('DOMContentLoaded', addEvents);
